import React, { useCallback } from 'react';

import Checkbox from '@mui/material/Checkbox';
import Typography from '@mui/material/Typography';

import { useField } from 'app-components/flux/transaction-rules/transactionRulesFormHooks';
import ExpandableCard from 'components/ExpandableCard';
import BoxField from 'components/Transactions/BoxField';

import useStyles from '../styles';

function MemoTarget() {
  const { cx, classes } = useStyles();
  const { value, onValueChange, error } = useField('memoTarget');

  const handleOnChange = useCallback(
    (value: React.SetStateAction<string>) => {
      if (typeof value === 'function') {
        // If value is a function, call it with current value
        onValueChange(value(''));
      } else {
        onValueChange(value);
      }
    },
    [onValueChange],
  );

  return (
    <>
      <BoxField
        className={cx(classes.notesTargetContainer, error ? classes.errorBorder : '')}
        id='rules-target-memo'
        label=''
        fullWidth
        placeholder='Add your note here'
        value={value || ''}
        onChange={handleOnChange}
        inputProps={{
          maxLength: 512,
        }}
        margin='dense'
      />
      {error && (
        <Typography variant='captionRegular' className={classes.errorText}>
          Required
        </Typography>
      )}
    </>
  );
}

export function MemoTargetCard(props: any) {
  const { classes, theme } = useStyles();
  const { value, onValueChange } = useField('isEnabledMemoTarget');

  const toggleEnabled = () => {
    onValueChange(!value);
  };

  return (
    <ExpandableCard
      id='rule-memo-target'
      className={classes.card}
      title='Add Note'
      cardHeaderProps={{ padding: `${theme.spacing(1.5)} ${theme.spacing(2)}` }}
      titleProps={{ variant: 'subtitle2' }}
      expandIcon={<Checkbox id='rule-memo-target-enabled' checked={value} onClick={toggleEnabled}></Checkbox>}
      isExpanded={value || !!props.hideToggle}
      hideToggle={!!props.hideToggle}
    >
      <MemoTarget />
    </ExpandableCard>
  );
}
